import React from 'react';

const WalletV3 = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M1.66699 4.58235V14.9971C1.66699 16.3776 2.78608 17.4967 4.16654 17.4967H16.6643C17.1244 17.4967 17.4975 17.1236 17.4975 16.6635V7.49849C17.4975 7.03833 17.1244 6.6653 16.6643 6.6653H3.74995C2.59956 6.6653 1.66699 5.73273 1.66699 4.58235V4.58235C1.66699 3.43196 2.59956 2.49939 3.74995 2.49939H13.3315C13.7917 2.49939 14.1647 2.87242 14.1647 3.33257V6.24871",
      stroke: "white",
      strokeWidth: "1.24977"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12.4971 12.0812C12.4971 10.9309 13.4296 9.99829 14.58 9.99829H17.4962V14.1642H14.58C13.4296 14.1642 12.4971 13.2316 12.4971 12.0812V12.0812Z",
      stroke: "white",
      strokeWidth: "1.24977"
    }
  )
);

export { WalletV3 };
//# sourceMappingURL=WalletV3.js.map
